import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // Attempt to get the initial auth state from sessionStorage
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return sessionStorage.getItem('isAuthenticated') === 'true';
    });
    
    const [userRole, setUserRole] = useState(() => {
        return sessionStorage.getItem('userRole') || 'guest';
    });

    // --- 凭据配置 (通过环境变量) ---
    
    // 1. 超级管理员 (Admin)
    const adminUser = process.env.REACT_APP_ADMIN_USER || 'jcwxt';
    const adminPass = process.env.REACT_APP_ADMIN_PASS || 'jcw123456!#!';
    
    // 2. 只读用户 (Read-only)
    const viewUser = process.env.REACT_APP_VIEW_USER || 'view';
    const viewPass = process.env.REACT_APP_VIEW_PASS || '123';

    // 3. 部门账号 (Departments)
    const deptCredentials = [
        {
            user: process.env.REACT_APP_DEPT_CK_USER || 'ck',
            pass: process.env.REACT_APP_DEPT_CK_PASS || '123',
            role: '筹开部'
        },
        {
            user: process.env.REACT_APP_DEPT_CWSW_USER || 'cwsw',
            pass: process.env.REACT_APP_DEPT_CWSW_PASS || '123',
            role: '财务商务部'
        },
        {
            user: process.env.REACT_APP_DEPT_YY_USER || 'yy',
            pass: process.env.REACT_APP_DEPT_YY_PASS || '123',
            role: '运营部'
        },
        {
            user: process.env.REACT_APP_DEPT_ZJB_USER || 'zjb',
            pass: process.env.REACT_APP_DEPT_ZJB_PASS || '123',
            role: '总经办'
        }
    ];

    useEffect(() => {
        // Persist auth state to sessionStorage
        sessionStorage.setItem('isAuthenticated', isAuthenticated);
        sessionStorage.setItem('userRole', userRole);
    }, [isAuthenticated, userRole]);

    const login = (username, password) => {
        // 管理员登录
        if (username === adminUser && password === adminPass) {
            setIsAuthenticated(true);
            setUserRole('admin');
            return true;
        }
        // 只读登录
        if (username === viewUser && password === viewPass) {
            setIsAuthenticated(true);
            setUserRole('readonly');
            return true;
        }
        const deptUser = deptCredentials.find(d => d.user === username && d.pass === password);
        if (deptUser) {
            setIsAuthenticated(true);
            setUserRole(deptUser.role);
            return true;
        }
        return false;
    };

    const logout = () => {
        setIsAuthenticated(false);
        setUserRole('guest');
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('userRole');
    };

    const value = {
        isAuthenticated,
        userRole, // Export role
        login,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};
